/**
 * Марка.
 *
 * По дизайну знак живёт ровно в двух местах — полоса окна и вход. В рабочем
 * экране бренда нет намеренно: там нужен канал, а не напоминание, чьё это
 * приложение. Поэтому компонент маленький и мест применения у него два.
 * Исключение — строка «В числе участников с» в профиле: там он стоит, как
 * знак Discord, рядом с датой прихода в Airel.
 *
 * Знак — не картинка в разметке, а фон: для светлой темы лежит отдельный
 * файл, где обе грани тёмные. Белая грань на светлом фоне пропадает, а
 * фильтром это не чинится — там свои цвета, не перекрашенные. Подмена по
 * `data-theme` живёт в css, чтобы не тащить тему в каждое место вызова.
 */
export function Mark({ size }: { size: "bar" | "auth" }) {
  // Слово AIREL стоит рядом текстом, поэтому знак для чтения с экрана нем:
  // иначе название прозвучит дважды подряд.
  return <span className={`brand-mark brand-mark-${size}`} aria-hidden="true" />;
}

/**
 * Название.
 *
 * Всегда прописными и всегда Geist — интерфейс при этом остаётся на Inter.
 * Фирменный шрифт здесь работает подписью, а не гарнитурой: имена, сообщения
 * и кнопки его не берут.
 *
 * Разрядка задаётся не здесь, а местом применения: она растёт вместе с
 * размером, 0.24 em в полосе окна и 0.34 em на входе.
 */
export function Word() {
  return <span className="brand-word">AIREL</span>;
}
